import * as AccordionPrimitive from "@radix-ui/react-accordion";

const { Root, Item, Content, Trigger } = AccordionPrimitive;

export { Root, Item, Content, Trigger };
